import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Alert from '@material-ui/lab/Alert';
import AlertTitle from '@material-ui/lab/AlertTitle';
import React, { useState } from 'react';
import { useObservable } from 'react-use-observable';
import { EAnticipationStatus } from 'v2/interfaces/user';
import eduzzAccountsService from 'v2/services/eduzzAccount';

const useStyles = makeStyles((theme) => ({
  alert: {
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      alignItems: 'center',
      textAlign: 'center',
    },
  },
  alertIcon: {
    [theme.breakpoints.down('xs')]: {
      fontSize: 42,
      margin: 0,
    },
  },
  alertAction: {
    [theme.breakpoints.down('xs')]: {
      marginLeft: 0,
      paddingLeft: 0,
    },
  },
}));

const ChargebackAlert = () => {
  const classes = useStyles();

  const [visible, setVisible] = useState(true);
  const [user] = useObservable(() => eduzzAccountsService.getUser(), []);

  const handleClose = () => {
    setVisible(false);
  };

  if (!visible) return null;
  if (!user || user?.anticipation_status === EAnticipationStatus.LIBERADO) return null;

  return (
    <>
      <Alert
        severity={user?.anticipation_status === EAnticipationStatus.BLOQUEADO ? 'error' : 'warning'}
        action={
          <Button color='primary' onClick={handleClose} aria-label='fechar'>
            Entendi
          </Button>
        }
        className={classes.alert}
        classes={{ icon: classes.alertIcon, action: classes.alertAction }}
      >
        <AlertTitle>Atenção</AlertTitle>
        <Typography variant='body1'>
          {user?.anticipation_status_message}{' '}
          <a
            href='https://ajuda.eduzz.com/hc/pt-br/articles/1260807649349-O-que-e-Chargeback-e-como-funcionam-seus-%C3%ADndices'
            target='_blank'
            rel='noopener noreferrer'
          >
            O que é chargeback?
          </a>
        </Typography>
      </Alert>
      <div className='m16' />
    </>
  );
};

export default ChargebackAlert;
